"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var arrow_1 = require("../icons/arrow");
var inputWrapper_1 = require("../inputWrapper");
var functions_1 = require("../../utils/functions");
var text_1 = require("../base/text");
var clickOutside_1 = require("../clickOutside");
var form_1 = require("../form");
var zoom_1 = require("../icons/zoom");
var zoomSmile_1 = require("../icons/zoomSmile");
exports.SearchableSelectbox = React.memo(function (_a) {
    var options = _a.options, name = _a.name, type = _a.type, onlyChildren = _a.onlyChildren, message = _a.message, languageCode = _a.languageCode, _b = _a.defaultOption, defaultOption = _b === void 0 ? null : _b, _c = _a.passive, passive = _c === void 0 ? false : _c, _d = _a.scroll, scroll = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "small" /* Small */ : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.placeholder, placeholder = _g === void 0 ? '' : _g, _h = _a.searchPlaceholder, searchPlaceholder = _h === void 0 ? '' : _h, _j = _a.onSelect, onSelect = _j === void 0 ? functions_1.NOOP : _j, _k = _a.noResultLabel, noResultLabel = _k === void 0 ? '' : _k;
    var _l;
    var _m = React.useState(false), showOptions = _m[0], toggleShowOptions = _m[1];
    var _o = React.useState(false), noResultVisibility = _o[0], setNoResultVisibility = _o[1];
    var _p = form_1.useForm(defaultOption, name, type, message), selectedOption = _p[0], setSelectedOption = _p[1], _type = _p[2], _message = _p[3];
    var optionsRef = React.useRef({});
    var searchInputRef = React.useRef({});
    var selectboxClassName = classnames_1.default('ty-input', 'ty-select', 'ty-bordered', 'ty-transition', "ty-input-" + size, {
        'ty-bordered-focus': showOptions,
    });
    var optionsWrapperClassName = classnames_1.default('ty-select-options', 'ty-bordered-focus', { 'ty-on': showOptions });
    var optionsListClass = classnames_1.default({ 'ty-options-scrollbar': !noResultVisibility });
    var onOptionClick = function (option) {
        if (option !== selectedOption) {
            setSelectedOption(option);
            handleCloseOptions();
            if (typeof onSelect === 'function') {
                onSelect(option);
            }
        }
    };
    var onSelectClick = function () {
        if (!passive) {
            if (!showOptions) {
                searchInputRef.current.focus();
            }
            toggleShowOptions(!showOptions);
        }
    };
    var handleCloseOptions = function () {
        toggleShowOptions(false);
        searchInputRef.current.value = '';
        searchInputRef.current.blur();
        search('');
    };
    var handleSearch = function (event) {
        var query = event.currentTarget.value;
        search(query);
    };
    var search = function (searchTerm) {
        var options = document.querySelectorAll("[name=" + name + "] .ty-select-option");
        var resultCount = options.length;
        options.forEach(function (option) {
            option.classList.remove('ty-display-none');
            if (!matches(searchTerm, option.innerText)) {
                option.classList.add('ty-display-none');
                resultCount--;
            }
        });
        setNoResultVisibility(resultCount <= 0);
    };
    var matches = function (query, item) {
        var convertor = turkishToEnglishString;
        if (languageCode !== 'tr') {
            convertor = germanToEnglishString;
        }
        return convertor(item.trim()).toLowerCase().indexOf(convertor(query.trim()).toLowerCase()) !== -1;
    };
    var turkishToEnglishString = function (str) {
        return str
            .replace(/ö/g, 'o')
            .replace(/ü/g, 'u')
            .replace(/ş/g, 's')
            .replace(/ç/g, 'c')
            .replace(/ı/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ö/g, 'O')
            .replace(/Ü/g, 'U')
            .replace(/Ş/g, 'S')
            .replace(/Ç/g, 'C')
            .replace(/İ/g, 'I')
            .replace(/Ğ/g, 'G');
    };
    var germanToEnglishString = function (str) {
        return str
            .replace(/ä/g, 'ae')
            .replace(/Ä/g, 'ae')
            .replace(/ü/g, 'ue')
            .replace(/Ü/g, 'ue')
            .replace(/ö/g, 'oe')
            .replace(/Ö/g, 'oe')
            .replace(/ß/g, 'ss');
    };
    React.useEffect(function () {
        setSelectedOption(defaultOption);
        search('');
    }, [options]);
    var arrowIcon = React.createElement(arrow_1.Arrow, { color: "default" /* Default */, direction: "down" /* Down */, size: size });
    if (showOptions) {
        arrowIcon = React.createElement(arrow_1.Arrow, { color: "orange" /* Orange */, direction: "up" /* Up */, size: size });
    }
    return (React.createElement(inputWrapper_1.InputWrapper, { passive: passive, type: _type, message: _message, label: label, size: size, onlyChildren: onlyChildren },
        React.createElement(clickOutside_1.ClickOutside, { onClickOutside: handleCloseOptions, condition: !passive },
            React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, position: "ty-relative" /* Relative */, backgroundColor: "ty-bg-beige" /* Beige */, className: selectboxClassName, onClick: onSelectClick, name: name, tabIndex: "-1" },
                React.createElement(text_1.Text, { color: "ty-color-dark-gray" /* DarkGray */ }, selectedOption ? (_l = selectedOption.selectedText, (_l !== null && _l !== void 0 ? _l : selectedOption.visual)) : placeholder),
                arrowIcon,
                React.createElement(styledLayout_1.StyledLayout, { forwardedRef: optionsRef, position: "ty-absolute" /* Absolute */, display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-column" /* Column */, className: optionsWrapperClassName, tabIndex: passive ? '-1' : '0' },
                    React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-row" /* Row */ },
                        React.createElement(styledLayout_1.StyledLayout, { onClick: function (e) { return e.stopPropagation(); }, className: "ty-search-div" },
                            React.createElement(styledLayout_1.StyledLayout, { className: "ty-search-wrapper", display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-row" /* Row */ },
                                React.createElement("input", { type: "text", ref: searchInputRef, className: "ty-search-input", onChange: handleSearch, placeholder: searchPlaceholder }),
                                React.createElement(zoom_1.Zoom, null)))),
                    React.createElement(styledLayout_1.StyledLayout, { className: optionsListClass },
                        options.map(function (option, index) {
                            var key = "select-option-" + label + "-" + index;
                            return (React.createElement("div", { className: "ty-select-option", key: key, onClick: function () { return onOptionClick(option); } }, option.visual));
                        }),
                        noResultVisibility && (React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-column" /* Column */, justifyContent: "ty-justify-content-center" /* Center */, className: "ty-no-result-wrapper" },
                            React.createElement(styledLayout_1.StyledLayout, { justifyContent: "ty-justify-content-center" /* Center */, display: "ty-display-flex" /* Flex */ },
                                React.createElement(zoomSmile_1.ZoomSmile, null)),
                            React.createElement(styledLayout_1.StyledLayout, { justifyContent: "ty-justify-content-center" /* Center */, display: "ty-display-flex" /* Flex */ },
                                React.createElement("span", null, noResultLabel))))))))));
});
